const type = 'advanced'
const path = '/advance/angular-node/angular/src/'
const name = 'main.ts'

export { type, path, name }
